const isNodeOnLastLevel = node => node.level === 3

export default isNodeOnLastLevel
